export enum ScannerRouteNames {
  SCANNER_ROOT = 'ScannerRoot',
}
